import React, { useState } from 'react';
import {ReactComponent as SearchIcon} from '../../assets/images/search.svg';
import {ReactComponent as CloseIcon} from '../../assets/images/close.svg';
const HeaderSearch = () => {
    const [searchActive, setSearchActive] = useState(false);
    const handleSearchToggler = () => {
        setSearchActive(!searchActive);    
    }

    return(
        <div className="c-header-search">
            <div className="search-toggler cursor-pointer p-16 relative" onClick={handleSearchToggler}>
                <span className="absolute inset-0 block flex items-center justify-center">
                    {!searchActive && <SearchIcon/> }
                    {searchActive && <CloseIcon/> }
                </span>
            </div>
            <div className={`search-bar absolute top-100 left-0 right-0 z-50 px-16 bg-white ${searchActive?'block':'hidden'}`}>
                <input className="border-1 border-gray-300 w-full rounded-none py-14 px-16 pr-40" placeholder="Search..." />
                <button className="border-none absolute right-18 top-0 opacity-50 block px-10 py-18"><SearchIcon/></button>
            </div>
        </div>
    )
}
export default HeaderSearch;